import baseRequest from './baseRequest';

export function getTerms() {
  return baseRequest.get('/api/text-screens/terms');
}
